import { render, staticRenderFns } from "./MMenu.vue?vue&type=template&id=6fb9010d&scoped=true&"
import script from "./MMenu.vue?vue&type=script&lang=js&"
export * from "./MMenu.vue?vue&type=script&lang=js&"
import style0 from "./MMenu.vue?vue&type=style&index=0&id=6fb9010d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb9010d",
  null
  
)

export default component.exports